
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Thermalwarmingsystem() {



  const cardData =
  {
    keyword: 'Thermal Warming System for Patients in India',
    heading: 'Pharmacle Health Care Private Limited: Thermal Warming System for Patients in India',
    headingDescription: 'Pharmacle Health Care Private Limited is a leading manufacturer of Thermal Warming Systems for Patients in India, offering advanced solutions designed to maintain optimal body temperature during surgical and critical care procedures. Our state-of-the-art warming systems utilize cutting-edge technology to provide consistent and controlled heat, effectively preventing hypothermia and enhancing patient safety. Trusted by top hospitals and healthcare facilities across the country, our systems are user-friendly, reliable, and integrate seamlessly into various clinical settings. Choose Pharmacle Health Care for superior thermal warming systems that elevate the standard of care and improve clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',



  "topPlaces": [
  {
    "title": "Therma Patient Warmer Device",
    "description": "The Therma Patient Warmer Device by Pharmacle Health Care Private Limited is an indigenously manufactured solution for effective convective warming therapy. Supplied with a complimentary patient blanket, it is widely installed in leading Indian hospitals. This system ensures reliable thermal regulation, enhancing patient comfort, safety, and recovery during surgeries."
  },
  {
    "title": "Therma Conductive Warming System",
    "description": "Pharmacle’s Therma Conductive Warming System prevents intraoperative hypothermia with advanced carbon fiber technology. Delivering uniform heat distribution through specialized warming mattresses and blankets, it is digitally controlled for accuracy—making it ideal for operating rooms and ICUs."
  },
  {
    "title": "Advanced Normothermia System",
    "description": "The Advanced Normothermia System by Pharmacle Health Care Private Limited offers a comprehensive solution for preventing and treating hypothermia in surgical settings. Using next-generation forced-air warming technology, it maintains stable core body temperature, accelerating patient recovery and improving clinical outcomes."
  },
  {
    "title": "IOB Patient Warming System",
    "description": "The Digital IOB Patient Warming System from Pharmacle Health Care Private Limited ensures consistent warming during anesthesia and recovery. Featuring a durable build, intuitive touch control interface, and multiple temperature modes, it is the preferred choice in critical care units across India."
  },
  {
    "title": "Cocoon Convective Warming System CWS 4000",
    "description": "Pharmacle’s Cocoon CWS 4000 is a microprocessor-based convective warmer offering highly precise temperature control. With auto-safety features, filter indicators, and CE/FDA compliance, it is trusted by hospitals prioritizing patient safety and advanced thermal therapy."
  },
  {
    "title": "Mistral-Air® Plus Warming Unit",
    "description": "The Mistral-Air® Plus Warming Unit distributed by Pharmacle Health Care ensures uniform air delivery through high-efficiency warming blankets. Its aerodynamic design and built-in safety functions allow optimal heat transfer, maintaining normothermia throughout surgical and post-operative care."
  },
  {
    "title": "Forced Air Warming System",
    "description": "Pharmacle’s Forced Air Warming System integrates a high-efficiency warming unit, disposable blankets, and precise temperature controls to deliver targeted thermal care. Designed for high-volume surgical centers, it significantly reduces perioperative hypothermia risks."
  },
  {
    "title": "Manual Patient Warming System",
    "description": "Pharmacle Health Care Private Limited offers a robust manual warming system designed for mid-sized clinics and ambulatory surgical centers. Featuring analog controls and durable heating elements, it provides dependable warming performance with minimal setup requirements."
  },
  {
    "title": "NICU Patient Warmer",
    "description": "The NICU Patient Warmer by Pharmacle Health Care Private Limited is specially designed for neonatal intensive care. Lightweight and portable, it provides precise thermal regulation for newborns, reducing the risk of neonatal hypothermia and ensuring safety in critical care environments."
  },
  {
    "title": "Air Warming System",
    "description": "Pharmacle’s Air Warming System delivers gentle and evenly distributed airflow for maintaining patient body temperature during extended surgical procedures. Equipped with smart control algorithms and temperature sensors, it ensures consistent patient safety and comfort."
  }
],

"services": [
    {
        "name": "Thermal Warming System for Patients India",
        "description": "Pharmacle Health Care provides advanced thermal warming systems for patients in India, designed to maintain optimal body temperature during surgeries, recovery, and critical care. These systems utilize precision thermal regulation technology to prevent hypothermia, enhance comfort, and promote better clinical outcomes. Widely used across hospitals and surgical centers, our thermal systems are trusted for their reliability and efficiency."
    },
    {
        "name": "India Thermal Patient Management Devices",
        "description": "We offer thermal patient management devices across India, aimed at ensuring safe and effective temperature regulation during medical procedures. These devices help maintain normothermia in patients, minimizing complications from hypothermia. Our thermal solutions are ideal for use in operating rooms, ICUs, and post-operative care units, offering healthcare providers dependable and consistent warming support."
    },
    {
        "name": "Thermal Regulation System for Hospitals",
        "description": "Pharmacle Health Care supplies thermal regulation systems specifically tailored for hospitals. These systems are essential for managing patient temperature across various clinical environments, including surgery and recovery. They ensure consistent heat delivery, enhance patient safety, and support quicker recovery by maintaining thermal stability throughout the patient care process."
    },
    {
        "name": "Surgical Thermal Warming Devices",
        "description": "Our surgical thermal warming devices are engineered to provide precise temperature control during operations. By maintaining core body heat, these devices reduce surgical risks associated with hypothermia and help improve recovery outcomes. Easy to operate and integrate into surgical workflows, they are a key component in modern temperature management protocols."
    },
    {
        "name": "Body Heating Equipment India",
        "description": "Pharmacle Health Care offers high-performance body heating equipment in India, developed to deliver controlled warmth to patients undergoing medical treatment. These systems play a crucial role in maintaining physiological stability, especially during surgeries and in trauma care. Designed for use in hospitals and clinics, our equipment is efficient, user-friendly, and compliant with healthcare standards."
    },
    {
        "name": "Patient Thermal Comfort Systems",
        "description": "We provide patient thermal comfort systems that prioritize both safety and well-being. These systems are designed to keep patients warm during procedures and recovery, preventing the discomfort and risks associated with low body temperature. With advanced sensors and temperature regulation capabilities, they ensure comfort without compromising on clinical performance."
    },
    {
        "name": "Hospital Patient Heat Support System",
        "description": "Our hospital patient heat support systems are essential tools for maintaining appropriate body temperature during medical treatments. These systems ensure that patients stay warm throughout various stages of care, reducing the incidence of hypothermia-related complications. Built for hospital environments, they offer durability, precision, and consistent thermal control."
    },
    {
        "name": "India Patient Temperature Control Solutions",
        "description": "Pharmacle Health Care delivers comprehensive patient temperature control solutions across India. Our systems are built to manage and stabilize body temperature in a wide range of clinical situations, from operating rooms to intensive care units. With advanced temperature sensors and adjustable settings, our solutions support both patient safety and medical efficiency."
    }
],
"tableData": [
    ["- Thermal Warming System for Patients India", "- India Thermal Patient Management Devices"],
    ["- Thermal Regulation System for Hospitals", "- Surgical Thermal Warming Devices"],
    ["- Body Heating Equipment India", "- Patient Thermal Comfort Systems"],
    ["- Hospital Patient Heat Support System", "- India Patient Temperature Control Solutions"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Our Thermal Warming System for Patients in India uses advanced technology to provide precise temperature regulation, ensuring patient safety and comfort during medical procedures. Designed to prevent hypothermia, our systems are reliable and effective in critical healthcare environments."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a complete range of Thermal Warming Systems for Patients in India, including heating blankets, warming devices, and temperature control systems. Our solutions are tailored for use in hospitals, operating rooms, and recovery areas to keep patients comfortable and safe."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Thermal Warming Systems for Patients are built with the highest standards of quality, ensuring long-lasting durability and performance. Each system is rigorously tested to meet safety standards, providing healthcare providers across India with reliable equipment for continuous use."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient comfort and safety are our top priorities. Our Thermal Warming Systems offer gentle, controlled warmth to prevent temperature-related complications during surgeries, improving patient outcomes and comfort throughout their medical treatments."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Thermal Warming Systems are adaptable to various healthcare settings across India, including hospitals, clinics, and intensive care units. We work closely with healthcare providers to ensure our systems meet their specific needs, enhancing overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Designed for seamless integration, our Thermal Warming Systems can be easily incorporated into existing medical setups. They work smoothly with other medical equipment, allowing healthcare professionals to maintain effective patient care without disruptions."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services to healthcare facilities in India, helping them select the right Thermal Warming Systems for their needs. Our dedicated support team also offers ongoing maintenance and troubleshooting to ensure optimal performance."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, we are committed to providing the best solutions for patient safety and comfort. Our Thermal Warming Systems are designed to regulate body temperature effectively, ensuring that patients in India receive the highest standard of care during medical procedures."
    }
]





















  }

  const faqData = [
    {
      question: "What is a Thermal Warming System for Patients?",
      answer: "A Thermal Warming System for patients is a medical device designed to maintain or raise a patient's body temperature during surgery or recovery. It uses heated air or electric elements to deliver warmth through blankets, pads, or other coverings to prevent hypothermia."
    },
    {
      question: "Why is a Thermal Warming System important for patients?",
      answer: "A Thermal Warming System is crucial for preventing hypothermia during surgeries, particularly under anesthesia, as it helps maintain normal body temperature, reduces the risk of complications, and improves recovery time."
    },
    {
      question: "Are Thermal Warming Systems available in India?",
      answer: "Yes, Thermal Warming Systems are available in India from manufacturers like Pharmacle Health Care Private Limited, which offers a range of forced air warming systems to ensure effective patient temperature management during medical procedures."
    },
    {
      question: "How does a Thermal Warming System work?",
      answer: "A Thermal Warming System typically uses a blower to circulate warm air through a warming blanket or pad, which is placed on the patient’s body. The system adjusts the temperature of the air to maintain a safe and comfortable body temperature."
    },
    {
      question: "Is Pharmacle Health Care’s Thermal Warming System suitable for all types of surgeries?",
      answer: "Yes, Pharmacle Health Care’s Thermal Warming Systems are designed for a wide range of surgeries and medical procedures where maintaining a patient’s body temperature is critical, including orthopedic, cardiac, and general surgeries."
    }
  ];
  
  const testimonialsData = [
    {
      text: "Pharmacle Health Care’s Thermal Warming Systems have been a game-changer in our hospital, ensuring that patients remain at a safe temperature during surgery and recovery.",
      name: "Dr. Neha Gupta, Fortis Hospital"
    },
    {
      text: "The thermal warming systems provided by Pharmacle have significantly improved the comfort and safety of our patients, especially in long surgeries where temperature control is vital.",
      name: "Dr. Vinod Sharma, Starlight Multispecialty Clinic"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Thermal Warming System for Patients in India",
    "description": "Explore Thermal Warming Systems for patients in India, offering advanced thermal regulation devices, surgical body heating equipment, and patient temperature control solutions for hospitals and clinical environments.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1516"
    }
  };
  
 
  

  

  return (
    <div>
 <Helmet>
    <title>Thermal Warming System for Patients in India | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Get Thermal Warming Systems for Patients in India. Medical solutions for thermal regulation, patient temperature control, and surgical heat support. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Thermal Warming System for Patients India, India Thermal Patient Management Devices, Thermal Regulation System for Hospitals, Surgical Thermal Warming Devices, Body Heating Equipment India, Patient Thermal Comfort Systems, Hospital Patient Heat Support System, India Patient Temperature Control Solutions"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/54.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thermalwarmingsystem;